import { render, staticRenderFns } from "./ProjectSummaryCard.vue?vue&type=template&id=9bfa77c6"
import script from "./ProjectSummaryCard.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports